import React from 'react';
import image1 from './images/image1.png';
import image2 from './images/image2.png';
import '../App.css';

import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

export default function Application() {
  const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.4 });
  const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.4 });

  return (
    <div className="container-fluid py-5 application-container text-white">
      <h1 className="text-center mb-5 gradient-text">Application Walkthrough</h1>

      <div className="row justify-content-center gy-5 application-content">
        
        {/* First Block: Left to Right Animation */}
        <div className="col-md-5 text-center">
          <motion.img
            ref={ref1}
            src={image1}
            alt="Live Production Status"
            initial={{ width: '20%', opacity: 0 }}
            animate={inView1 ? { width: '100%', opacity: 1 } : {}}
            transition={{ duration: 1 }}
            className="img-fluid mb-4"
          />
          <ul className="list-unstyled text-start mx-auto" style={{ maxWidth: '400px' }}>
            <li className="mb-3 text-warning">
              Live Production Status:{' '}
              <span className="text-light">Instantly track what’s running, what’s delayed, and what’s done.</span>
            </li>
            <li className="mb-3 text-warning">
              Machine & Department Overview:{' '}
              <span className="text-light">Visual summaries of machine usage, downtime, and output per department.</span>
            </li>
          </ul>
        </div>

        {/* Second Block: Right to Left Animation */}
        <div className="col-md-5 text-center">
          <motion.img
            ref={ref2}
            src={image2}
            alt="Setup Departments"
            initial={{ width: '20%', opacity: 0, x: '80%' }}
            animate={inView2 ? { width: '100%', opacity: 1, x: 0 } : {}}
            transition={{ duration: 1 }}
            className="img-fluid mb-4"
          />
          <ul className="list-unstyled text-start mx-auto" style={{ maxWidth: '400px' }}>
            <li className="mb-3 text-warning">
              Setup Departments & Machines:{' '}
              <span className="text-light">Add departments, machines, and manage lists from one unified interface.</span>
            </li>
            <li className="mb-3 text-warning">
              Custom Order Flow:{' '}
              <span className="text-light">Rearrange production steps to match your exact operational needs.</span>
            </li>
          </ul>
        </div>

      </div>
    </div>
  );
}


















// import React from 'react'
// import image1 from './images/image1.png'
// import image2 from './images/image2.png'
// import '../App.css' // Keep only if you're using global styles like gradients

// export default function Application() {
//   return (
//     <div className="container-fluid py-5 application-container text-white">
//       <h1 className="text-center mb-5 gradient-text">Application Walkthrough</h1>

//       <div className="row justify-content-center gy-5 application-content">
//         {/* First Content Block */}
//         <div className="col-md-5 text-center">
//           <img src={image1} alt="Live Production Status" className="img-fluid mb-4" />
//           <ul className="list-unstyled text-start mx-auto" style={{ maxWidth: '400px' }}>
//             <li className="mb-3 text-warning">
//               Live Production Status:{' '}
//               <span className="text-light">Instantly track what’s running, what’s delayed, and what’s done.</span>
//             </li>
//             <li className="mb-3 text-warning">
//               Machine & Department Overview:{' '}
//               <span className="text-light">Visual summaries of machine usage, downtime, and output per department.</span>
//             </li>
//           </ul>
//         </div>

//         {/* Second Content Block */}
//         <div className="col-md-5 text-center">
//           <img src={image2} alt="Setup Departments" className="img-fluid mb-4" />
//           <ul className="list-unstyled text-start mx-auto" style={{ maxWidth: '400px' }}>
//             <li className="mb-3 text-warning">
//               Setup Departments & Machines:{' '}
//               <span className="text-light">Add departments, machines, and manage lists from one unified interface.</span>
//             </li>
//             <li className="mb-3 text-warning">
//               Custom Order Flow:{' '}
//               <span className="text-light">Rearrange production steps to match your exact operational needs.</span>
//             </li>
//           </ul>
//         </div>
//       </div>
//     </div>
//   )
// }

